// "Your portfolio data" (P1.10, owner 4 Nov): what a person can always remove or
// narrow of her own Brand Ambassador data — with or without the Brand
// Ambassador role, and while BA is switched off. employee-service never gates
// these (WP-2c), so the page that uses them sits behind no BA gate either.
//
// The only visibility this file ever sends is 'private' (copyGuard.test.ts): it
// narrows links, never widens them. Creating, editing and publishing stay on My
// Portfolio, behind the role (baProfileService).
import { gatewayApi } from '@/lib/hrApi';

const ME = '/api/v1/employees/me/ba-profile';

/** One of her images: never a key or a URL. */
export interface BaPrivacyMedia { id: string; caption: string | null; removed: boolean; review_status?: string }

/** GET /me/ba-profile/privacy: no draft, no revision content, no image links. */
export interface BaPrivacyView {
  id: string;
  publication: { status: 'published' | 'unpublished'; version: number; published_at?: string | null; unpublished_at?: string | null };
  submitted_revision: { id: string; revision_no: number } | null;
  media: BaPrivacyMedia[];
  /** Her profile links that are not private (catalogue or public). */
  social_links: { id: string; platform: string; visibility: string }[];
}

/** null = she has no BA portfolio data (the service's "not available" 404). */
export async function getMyBaPrivacy(): Promise<BaPrivacyView | null> {
  try {
    return (await gatewayApi.get<BaPrivacyView>(`${ME}/privacy`)).data;
  } catch (e) {
    if ((e as { response?: { status?: number } })?.response?.status === 404) return null;
    throw e;
  }
}

/** Withdraw consent: leave the catalogue now. */
export const privacyUnpublish = async (): Promise<void> => { await gatewayApi.post(`${ME}/unpublish`); };
/** Withdraw the submission that is with the company for review. */
export const privacyWithdraw = async (): Promise<void> => { await gatewayApi.post(`${ME}/withdraw`); };
export const privacyDeleteImage = async (id: string): Promise<void> => { await gatewayApi.delete(`${ME}/media/${id}`); };
export const privacyMakeLinkPrivate = async (id: string): Promise<void> => {
  await gatewayApi.put(`${ME}/social-links/${id}`, { visibility: 'private' });
};
